import { DoodApiError } from '@shared/interfaces/error.interface';
import { EligiblePromotion } from '@core/services/api/bogof/bogof-api.service';

export interface EligiblePromotionsState {
  data: EligiblePromotion[] | null;
  isLoaded: boolean;
  isLoading: boolean;
  hasError: boolean;
  error: DoodApiError | null;
}

export const ELIGIBLE_PROMOTIONS_STORE_KEY = 'EligiblePromotions';

export const ELIGIBLE_PROMOTIONS_STORE_INITIAL_STATE: EligiblePromotionsState = {
  data: null,
  isLoaded: false,
  isLoading: false,
  hasError: false,
  error: null,
};
